import { GlobalAppState } from '@state/store';

export const getHotelPath = (state: GlobalAppState) => state.hotel.path || '';
